module.exports = __webpack_public_path__ + "fcdf511048b0809402dbf7426bcccc35.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/img/machismo_inactive.svg
// module id = 60
// module chunks = 0